import styled from "@emotion/styled";
import { Grid } from "@mui/material";
import React from "react";
import MDBox from "../../../Components/MDBox";
import MDButton from "../../../Components/MDButton";
import MDTypography from "../../../Components/MDTypography";
import { v4 as uuid } from "uuid";
const CustomDivider = styled("div")(({ theme }) => ({
  border: `1px grey solid`,
  background: "grey",
}));
export default function FinalStep(props: { FinalGhabz: any }) {
  const { FinalGhabz } = props;

  return (
    <MDBox px={2}>
      <MDBox>
        <MDBox bgColor={"#f0f2f5"} borderRadius={5} p={"10px 5px"} mb={5}>
          <MDTypography fontSize={14}>قالب قبض شما با موفقیت ثبت شد در قسمت زیر اطلاعات مربوط را مشاهده میکنید.</MDTypography>
        </MDBox>
        <Grid item container flexDirection={"column"}>
          <Grid item sx={{ width: "100%" }}>
            <MDBox py={1}>
              <Grid container justifyContent={"space-between"} alignItems={"center"}>
                <Grid item>
                  <MDTypography fontSize={14}>قالب قبض</MDTypography>
                </Grid>
              </Grid>
            </MDBox>
          </Grid>
        </Grid>
        <CustomDivider />
        <Grid container sx={{ mb: 2, border: "4px double black", mt: 1 }} textAlign="center">
          <Grid container item>
            <Grid
              item
              xs={3}
              md={3}
              lg={3}
              sx={{
                border: "2px black solid",
                borderTop: 0,
                borderLeft: 0,
                background: "lightgray",
              }}
            >
              <MDTypography fontWeight="regular">نام عوارض</MDTypography>
            </Grid>
            <Grid item xs={3} md={3} lg={3} sx={{ border: "2px black solid", borderTop: 0, borderLeft: 0 }}>
              <MDTypography fontWeight="regular">{FinalGhabz.avarezName}</MDTypography>
            </Grid>
            <Grid
              item
              xs={3}
              md={3}
              lg={3}
              sx={{
                border: "2px black solid",
                borderTop: 0,
                borderLeft: 0,
                background: "lightgray",
              }}
            >
              <MDTypography fontWeight="regular">نام بانک</MDTypography>
            </Grid>
            <Grid
              item
              xs={3}
              md={3}
              lg={3}
              sx={{
                border: "2px black solid",
                borderTop: 0,
                borderLeft: 0,
                borderRight: 0,
              }}
            >
              <MDTypography fontWeight="regular">{FinalGhabz.bankAccountBankName}</MDTypography>{" "}
            </Grid>
            <Grid
              item
              xs={3}
              md={3}
              lg={3}
              sx={{
                border: "2px black solid",
                borderTop: 0,
                borderLeft: 0,
                background: "lightgray",
              }}
            >
              <MDTypography fontWeight="regular">فرمول</MDTypography>
            </Grid>
            <Grid item xs={3} md={3} lg={3} sx={{ border: "2px black solid", borderTop: 0, borderLeft: 0 }}>
              <MDTypography fontWeight="regular">{FinalGhabz.formula}</MDTypography>
            </Grid>
            <Grid
              item
              xs={3}
              md={3}
              lg={3}
              sx={{
                border: "2px black solid",
                borderTop: 0,
                borderLeft: 0,
                background: "lightgray",
              }}
            >
              <MDTypography fontWeight="regular">پیام عوارض</MDTypography>
            </Grid>
            <Grid
              item
              xs={3}
              md={3}
              lg={3}
              sx={{
                border: "2px black solid",
                borderTop: 0,
                borderLeft: 0,
                borderRight: 0,
              }}
            >
              <MDTypography fontWeight="regular">{FinalGhabz.message}</MDTypography>
            </Grid>
          </Grid>
          <Grid container item>
            <Grid
              item
              xs={12}
              md={12}
              lg={12}
              sx={{
                borderBottom: "2px black solid",
                py: 1.5,
                background: "lightgray",
              }}
            >
              <MDTypography fontWeight="bold" fontSize={16}>
                پارامتر های قبض
              </MDTypography>
            </Grid>
            <Grid container item sx={{ borderBottom: "2px black solid", py: 1.5 }}>
              {FinalGhabz.ghabzFields.map((r: any) => {
                return (
                  <Grid xs={12} md={12} lg={12} item key={r.fieldKey}>
                    {`${r.fieldName} (${r.symbole})`}
                  </Grid>
                );
              })}
            </Grid>
          </Grid>
          <Grid container item>
            <Grid
              item
              xs={12}
              md={12}
              lg={12}
              sx={{
                borderBottom: "2px black solid",
                py: 1.5,
                background: "lightgray",
              }}
            >
              <MDTypography fontWeight="bold" fontSize={16}>
                شروط قبض
              </MDTypography>
            </Grid>
            <Grid container item columns={10}>
              <Grid
                xs={2}
                md={2}
                lg={2}
                item
                sx={{
                  border: "2px black solid",
                  borderTop: 0,
                  borderLeft: 0,
                  background: "grey",
                }}
              >
                <MDTypography color="white" fontSize={16} py={0.2}>
                  نماد
                </MDTypography>
              </Grid>
              <Grid
                xs={2}
                md={2}
                lg={2}
                item
                sx={{
                  border: "2px black solid",
                  borderTop: 0,
                  borderLeft: 0,
                  background: "grey",
                }}
              >
                <MDTypography color="white" fontSize={16} py={0.2}>
                  مقدار کمینه
                </MDTypography>
              </Grid>
              <Grid
                xs={2}
                md={2}
                lg={2}
                item
                sx={{
                  border: "2px black solid",
                  borderTop: 0,
                  borderLeft: 0,
                  background: "grey",
                }}
              >
                <MDTypography color="white" fontSize={16} py={0.2}>
                  مقدار بیشینه
                </MDTypography>
              </Grid>
              <Grid
                xs={2}
                md={2}
                lg={2}
                item
                sx={{
                  border: "2px black solid",
                  borderTop: 0,
                  borderLeft: 0,
                  background: "grey",
                }}
              >
                <MDTypography color="white" fontSize={16} py={0.2}>
                  مقدار برابری
                </MDTypography>
              </Grid>
              <Grid
                xs={2}
                md={2}
                lg={2}
                item
                sx={{
                  border: "2px black solid",
                  borderTop: 0,
                  borderLeft: 0,
                  borderRight: 0,
                  background: "grey",
                }}
              >
                <MDTypography color="white" fontSize={16} py={0.2}>
                  مقدار پارامتر
                </MDTypography>
              </Grid>
              {FinalGhabz.ghabzRows?.map((r: any, i: number) => {
                return (
                  <Grid container item key={uuid()} columns={10}>
                    <Grid xs={2} md={2} lg={2} item>
                      <MDTypography color="dark" fontSize={14} py={0.2}>
                        {r.paramName || ""}
                      </MDTypography>
                    </Grid>
                    <Grid xs={2} md={2} lg={2} item>
                      <MDTypography color="dark" fontSize={14} py={0.2}>
                        {r.paramMin.toString().replace(/^0([-.]?[0]*)$/g, "----") || ""}
                      </MDTypography>
                    </Grid>
                    <Grid xs={2} md={2} lg={2} item>
                      <MDTypography color="dark" fontSize={14} py={0.2}>
                        {r.paramMax.toString().replace(/^0([-.]?[0]*)$/g, "----") || ""}
                      </MDTypography>
                    </Grid>
                    <Grid xs={2} md={2} lg={2} item>
                      <MDTypography color="dark" fontSize={14} py={0.2}>
                        {r?.paramEqual?.toString().replace(/^0([-.]?[0]*)$/g, "----") || ""}
                      </MDTypography>
                    </Grid>

                    <Grid xs={2} md={2} lg={2} item>
                      <MDTypography color="dark" fontSize={14} py={0.2}>
                        {r.paramAmount || ""}
                      </MDTypography>
                    </Grid>
                  </Grid>
                );
              })}
            </Grid>
          </Grid>
        </Grid>
        <MDButton
          sx={{ margin: 2 }}
          onClick={() => {

            window.open(`/PrintHtml?comp=ghabz&Id=${FinalGhabz.id}`);
          }}
          variant="gradient"
          color="primary"
        >
          چاپ
        </MDButton>
      </MDBox>
    </MDBox>
  );
}
